import client from './client';

export const leadsApi = {
  /** formId : identifiant du form_definitions correspondant (devis/rappel/contact) */
  submit: (formId, data) => client.post('/leads', { form_id: formId, data }, { auth: false }),

  // Back Office
  list: (statut) => client.get(`/admin/leads${statut ? `?statut=${statut}` : ''}`),
  update: (id, data) => client.put(`/admin/leads/${id}`, data),
  remove: (id) => client.delete(`/admin/leads/${id}`),
};
